import React from 'react';

interface PathToggleProps {
  showPath: boolean;
  setShowPath: (value: boolean) => void;
}

const PathToggle: React.FC<PathToggleProps> = ({ showPath, setShowPath }) => {
  return (
    <div className="path-toggle">
      <span>Show Path: {showPath ? 'On' : 'Off'}</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={showPath}
          onChange={() => setShowPath(!showPath)}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default PathToggle;